export * from './ActorQueryOperationUpdateCompositeUpdate';
